import { RefObject, useCallback, useState } from "react"
import { useResizeObserver } from "@react-hookz/web"

export type ContainerSize = {
  width: number
  height: number
}

const useContainerResize = (
  containerRef: RefObject<HTMLElement>,
  skipForMobile?: boolean,
): ContainerSize => {
  const [containerSize, setContainerSize] = useState<ContainerSize>({
    width: 0,
    height: 0,
  })

  const onResize = useCallback(
    ({ contentRect }: Partial<ResizeObserverEntry>) => {
      if (skipForMobile) return
      const { width, height } = contentRect || {}
      setContainerSize({
        width: width || containerSize.width,
        height: height || containerSize.height,
      })
    },
    [skipForMobile, containerSize.width, containerSize.height],
  )

  useResizeObserver(containerRef.current, onResize)

  return containerSize
}

export default useContainerResize
